// extracted by mini-css-extract-plugin
module.exports = {"modalSubHeading":"ModalSubSection_modalSubHeading__1pfZy","modalSubSection":"ModalSubSection_modalSubSection__2tNuA"};